// extracted by mini-css-extract-plugin
export var filesTableWrapper = "eea23e09c67e23702a45c957860c654a-css";
export var filesTable = "_18e3c166f1bc0c46148a62e8ac494697-css";
export var filesTableCell = "d9f8ab62766c08a724bac9f3314f21fc-css";
export var filesTableCell_isRemoveBtnCell = "_89fb83c5d3aad0fc16692fbd12c586d7-css";
export var fileLink = "_0ab2c0c5c439f731eba48c5e4c29c7f8-css";